import React, { Component } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import { Async } from 'react-select'
import GlobalHelper from "../GlobalHelper.jsx";

class ProductSelect extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            multi: this.props.multi || false,
            integrationKey: this.props.integrationKey || "",
            options: [],
            selectedOptions: null,
            types: this.props.types || ['matrix-item', 'single'],
        }

        const defaultCallback = () => { }
        this.name = this.props.name
        this.onChange = this.props.onChange || defaultCallback
        this.handleChange = this.handleChange.bind(this)
        this.loadProducts = this.loadProducts.bind(this)
    }

    handleChange(selectedOptions) {
        if (this.state.multi) {
            if (selectedOptions === null) {
                this.props.onChange([], "")
            } else {
                var values = []
                var labels = []
                selectedOptions.forEach(elem => {
                    values.push(elem.value)
                    labels.push(elem.label)
                })
                this.props.onChange(values, labels.join(','))
            }
        } else {
            let val = null
            let label = ''
            if (selectedOptions) {
                val = selectedOptions.value
                label = selectedOptions.label
            }
            this.onChange(val, label)
        }
        this.setState({
            selectedOptions: selectedOptions
        });

    }


    loadProducts(input, callback) {
        let filters = {}
        if (this.state.integrationKey != "") {
            filters = {
                "{oneOf}": {
                    "{nested};externalLinks": {
                        "externalLinks.integrationKey": this.state.integrationKey,
                    },
                    "uniqueExternalId": `{text};*${this.state.integrationKey}*`
                }
            }
        }
        AppContext.getApiClient().post('/products/search', {
            filters: filters,
            keywords: GlobalHelper.formatSearchKeywords(input),
            types: this.state.types,
        }).then((response) => {
            const opt = response.data?.map(p => {
                return { value: p.id, label: p.attributes.title }
            })
            callback(null, {
                options: opt,
                complete: false,
            })
        })
    }

    componentWillReceiveProps(nextProps) {
        this.loadValue(nextProps.value)
    }

    componentDidMount() {
        this.loadValue(this.props.value)
    }



    loadValue(value) {
        if (this.state.multi) {
            let promises = []
            for (let v of value) {
                promises.push(AppContext.getApiClient().get('/products/' + v))
            }
            Promise.all(promises).then(res => {
                this.setState({
                    selectedOptions: res.map(product => {
                        return {
                            value: product.id,
                            label: product.attributes.title,
                        }
                    })
                })
            })

        } else {
            if (value) {
                AppContext.getApiClient().get('/products/' + value).then(res => {
                    this.setState({
                        selectedOptions: {
                            value: res.id,
                            label: res.attributes.title,
                        }
                    })
                })
            }
        }
    }

    render() {
        return (
            <Async
                multi={this.state.multi}
                name={this.name}
                ignoreAccents={false}
                filterOptions={this.state.multi ? true : false}
                value={this.state.selectedOptions}
                onChange={this.handleChange}
                onBlurResetsInput={false}
                loadOptions={this.loadProducts}
            />
        )
    }
}

export default ProductSelect





// WEBPACK FOOTER //
// ./src/common/product-selection/selection.component.jsx